module.exports = __webpack_public_path__ + "img/destination.e1e0c833.svg";